import { render } from "./RegionsConfigsLotteryCotacao.vue?vue&type=template&id=29ca89e2&scoped=true"
import script from "./RegionsConfigsLotteryCotacao.vue?vue&type=script&lang=js"
export * from "./RegionsConfigsLotteryCotacao.vue?vue&type=script&lang=js"

import "./RegionsConfigsLotteryCotacao.vue?vue&type=style&index=0&id=29ca89e2&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-29ca89e2"]])

export default __exports__